/**
 * Backend expects short file types (e.g. "png") for IFileInfoRequest.fileType,
 * while browsers report MIME types (e.g. "image/png") on File.type.
 */
const MIME_TO_EXT: Record<string, string> = {
  "image/png": "png",
  "image/x-png": "png",
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/pjpeg": "jpg",
  "image/gif": "gif",
  "image/webp": "webp",
  "image/svg+xml": "svg",
  "image/bmp": "bmp",
  "image/x-ms-bmp": "bmp",
  "image/x-icon": "ico",
  "image/vnd.microsoft.icon": "ico",
};

/**
 * Returns a lowercase extension suitable for API payloads (`png`, `jpg`, …).
 */
export function normalizeImageFileTypeForApi(
  mimeType: string,
  fileName?: string
): string {
  const trimmed = mimeType.trim().toLowerCase();
  if (trimmed && !trimmed.includes("/")) {
    return trimmed.replace(/^\./, "");
  }
  if (trimmed && MIME_TO_EXT[trimmed]) {
    return MIME_TO_EXT[trimmed];
  }
  if (trimmed.startsWith("image/")) {
    const sub = trimmed.slice("image/".length).split("+")[0];
    if (sub) return sub === "jpeg" ? "jpg" : sub;
  }
  const fromName = fileName?.match(/\.([a-z0-9]+)$/i)?.[1]?.toLowerCase();
  if (fromName) return fromName === "jpeg" ? "jpg" : fromName;
  return "png";
}
